var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishListPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "12px",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WishListPrivate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wish-Lists",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Dashboard-\\u2014-Wish-Lists",
    transform: "translate(-395.000000, -523.000000)",
    fill: "#848484",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list-card",
    transform: "translate(221.000000, 362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "event-basics-in-list-form",
    transform: "translate(-83.000000, -88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock-open"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.375,254.25 L265.8125,254.25 L265.8125,252.5625 C265.8125,250.598437 264.214063,249 262.25,249 C260.285937,249 258.6875,250.598437 258.6875,252.5625 L258.6875,254.25 L258.125,254.25 C257.503906,254.25 257,254.753906 257,255.375 L257,259.875 C257,260.496094 257.503906,261 258.125,261 L266.375,261 C266.996094,261 267.5,260.496094 267.5,259.875 L267.5,255.375 C267.5,254.753906 266.996094,254.25 266.375,254.25 Z M263.9375,254.25 L260.5625,254.25 L260.5625,252.5625 C260.5625,251.632031 261.319531,250.875 262.25,250.875 C263.180469,250.875 263.9375,251.632031 263.9375,252.5625 L263.9375,254.25 Z",
    id: "WishListPrivate"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishListPrivate);
export default __webpack_public_path__ + "static/media/WishListPrivate.cab043f74a7fe8f33449b719ae5874f3.svg";
export { ForwardRef as ReactComponent };